module.exports = __webpack_public_path__ + "img/guizhouHints_4.f532ea46.jpg";